import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from 'src/app/app.state';
import { User } from '../user.model';
import { EnvironmentLoaderService } from 'src/app/shared/services/environment-loader.service';
import { UserCreateOrEditModalComponent } from '../user-create-or-edit-modal/user-create-or-edit-modal.component';
import { ActionLogModalComponent } from 'src/app/shared/components/modals/actionlog-modal/action-log-modal/action-log-modal.component';
import { EntityType } from '../../prices/action-log';
import { RequiresFeatureRoleDirective } from '../../../shared/directives/requires-feature-role.directive';
import { UsersListComponent } from '../users-list/users-list.component';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';
import { UserListStateService } from './user-list.state.service';
import { Observable } from 'rxjs';
import { TextSearchComponent } from 'src/app/shared/components/text-search/text-search.component';
import { AdmOrgTypeaheadComponent } from 'src/app/shared/components/adm-org-typeahead/adm-org-typeahead.component';
import { Organization } from '../../organization/organization-models';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatOption } from '@angular/material/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'adm-users-overview',
  templateUrl: './users-overview.component.html',
  styleUrls: ['./users-overview.component.scss'],
  imports: [
    CustomDropDownArrowDirective,
    RequiresFeatureRoleDirective,
    UsersListComponent,
    TextSearchComponent,
    AdmOrgTypeaheadComponent,
    MatIcon,
    MatFormField,
    MatLabel,
    MatOption,
    MatCheckbox,
    MatButton,
    ReactiveFormsModule,
    MatSelectModule,
  ],
  providers: [UserListStateService],
})
export class UsersOverviewComponent {
  state = inject(UserListStateService);
  private dialog = inject(MatDialog);
  appState = inject(AppState);
  private environmentLoaderService = inject(EnvironmentLoaderService);
  public roles = this.environmentLoaderService.virtualRoles;

  public openActionLog() {
    this.dialog.open(ActionLogModalComponent, {
      data: { organizations: this.state.fetchedOrganizations(), entityType: EntityType.PortalUser },
      disableClose: true,
      width: '1024px',
    });
  }

  public openCreateUserModal() {
    const dialogRef = this.dialog.open(UserCreateOrEditModalComponent, {
      data: { userRoles: this.state.userRoles },
    });

    dialogRef.afterClosed().subscribe(user => {
      this.refreshAfterUpdate(user);
    });
  }

  organizationsFetched(orgnizations: Organization[] | null) {
    this.state.fetchedOrganizations.set(orgnizations ?? []);
  }

  organizationSelected = (org?: Organization | null) => {
    this.state.ToFirstPage({
      organizationId: org ? org.id : null,
    });
  };

  public async refreshAfterUpdate(user: User | null) {
    if (!user) {
      return;
    }
    this.state.triggerRefresh();
  }

  public async refreshAfterDelete(user: User) {
    this.state.triggerRefresh();
  }

  public resetFilter() {
    this.state.resetFilter();
  }

  querySearchInput = (source: Observable<string>) => {
    source.subscribe(value => {
      this.state.ToFirstPage({
        query: value && value.length > 0 ? value : null,
      });
    });
  };
}
